"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
function CarInfo(props) {
    var top = props.top, topBg = props.topBg, bottom = props.bottom;
    return (react_1.default.createElement("div", { className: "azgazui__card-info" },
        react_1.default.createElement("div", { className: classnames_1.default('azgazui__card-top-part', {
                'top-bg': topBg,
            }) }, top),
        bottom));
}
exports.default = CarInfo;
CarInfo.displayName = 'CarInfo';
CarInfo.propTypes = {
    top: prop_types_1.default.node.isRequired,
    topBg: prop_types_1.default.bool,
    bottom: prop_types_1.default.node.isRequired,
};
CarInfo.defaultProps = {
    topBg: false,
};
